define('SageDotCom/Components/PartnerSearchResults',["Pagination",
    "underscore",
    "SageDotCom/DataLayer/tealium",
    "SageDotCom/DataLayer/Events/findPartnerSearch",
    "SageDotCom/DataLayer/Events/bodySelect",
    "eventManager",
    "score_bootstrap/Utils/UrlHelper",
    "text!SageDotCom/Components/Templates/PartnerSearchResult.html"],
    function ($, _, tealium, findPartnerSearch, bodySelectEvent, eventManager, urlHelper, partnerSearchResultTemplate) {

        function PartnerSearchResults(scope, partnerSearchTitleLabel, showContactsDetailsLabel, hideContactsDetailsLabel, searchTermsLabel, partnerSearchPaginationStatsLabel,
            specialismsTitle, descriptionTitle, certificationsTitle, visitMarketplace, contactPartnerButton, territory, numberOfResultsPerPage, hideEmail, hideWebsite, hideTelephone, useJsonData) {
            var $partnerSearchResultsTemplateDiv = $(".js-partner-search-results-template", scope);
            var $partnerSearchStatsTitle = $(".js-partner-search-stats", scope);
            var $partnerMatchingFilterResultsSpan = $("#filter-matching-results", scope);
            var $partnerSearchTermsSpan = $("#partner-search-terms", scope);
            var $noResultsDiv = $(".no-results-message", scope);
            var $hideOnLoadDiv = $(".js-hide-on-load", scope);
            var $paginationContainer = $("#pagination-container", scope);
            var $partnerContacted = "";

            var mappedQuery = {
                searchText: "",
                location: {
                    address: "",
                    longitude: "",
                    latitude: "",
                    distance: "",
                    unit: "",
                },
                partnerType: "",
                territory: territory,
                variants: [],
                metricUnits: "",
                useJsonData: useJsonData
            };

            var results = {
                partners: [],
                options: {
                    HideEmail: hideEmail,
                    HideWebsite: hideWebsite,
                    HideTelephone: hideTelephone
                },
                metricUnits: ""
            };

            // this variable is introduced to not call api service each time on filter change
            var filteredResults = {
                partners: [],
                options: {
                    HideEmail: hideEmail,
                    HideWebsite: hideWebsite,
                    HideTelephone: hideTelephone
                },
                metricUnits: ""
            };

            // convert underscore to mustache syntax
            _.templateSettings.interpolate = /\{\{(.+?)\}\}/g;

            function showResults() {
                $partnerSearchResultsTemplateDiv.empty();
                $paginationContainer.empty();

                if (checkIfRequiredFieldsAreEmpty()) {
                    return;
                }

                $hideOnLoadDiv.show();

                var tokenElement = $('input[name="__RequestVerificationToken"]', scope);
                var token = tokenElement.length > 0 ? tokenElement.val() : null;
                if (token) {
                    $.ajax({
                        url: "/partnersearchresult",
                        headers: {
                            "__RequestVerificationToken": token
                        },
                        type: "POST",
                        data: mappedQuery,
                        dataType: "json",
                        success: function (response) {
                            var partners = flatteningAndSortingPartnerResults(response.results);

                            setPartnerSearchResultTitle(partners.length);
                            checkIfThereIsNoResults(partners);
                            setPartnerSearchTerms();

                            var partnerSearchResultTemplateAfterDatasourceReplacement =
                                setPartnerSearchResultTemplate();

                            results.partners = partners;
                            filteredResults.partners = partners;
                            $partnerMatchingFilterResultsSpan.html("");

                            var specialisms = _.map(results.partners,
                                function (partner) {
                                    var specialismsLength = _.filter((partner.variants || []), { type: "specialism" });
                                    return specialismsLength.map(function (item) {
                                        return item.variantName;
                                    }).filter(function (variant) {
                                        return variant !== "";
                                    });
                                });
                            //specialisms without empty array
                            var specialismsArray = specialisms.filter(function (item) {
                                return item.length > 0;
                            });

                            if (specialismsArray.length > 0 || results.partners.length === 0) {
                                eventManager.trigger("partner-search-filter-triggered", results.partners);
                            }

                            eventManager.trigger("partner-search-map-triggered",
                                results.partners,
                                mappedQuery.location,
                                true);

                            if (results.partners.length === 0) {
                                $(".js-partner-search-results-template", scope).html("");
                                $(".stats", scope).html("");
                            } else {
                                setPagination(partnerSearchResultTemplateAfterDatasourceReplacement);
                            }

                            $hideOnLoadDiv.hide();


                            $(".contact-options a", scope).click(function (event) {
                                var extendedData = {
                                    "partnername": $(this).data("tracking"),
                                    "contactoption": $(this).data("contactoption"),
                                    "label": $(this).text()
                                };
                                var eventSchema = findPartnerSearch.GenerateEventMetadata(scope, extendedData);
                                tealium.event(eventSchema);
                            });
                        },
                        error: function (xhr) {
                            $(scope).hide(); // hide the component on error
                        }
                    });
                }
            }

            showResults();

            function checkIfRequiredFieldsAreEmpty() {
                return mappedQuery.location.address == "" &&
                    mappedQuery.location.latitude == "" &&
                    mappedQuery.location.longitude == "";
            }

            function flatteningAndSortingPartnerResults(responseResults) {
                var partners = _.map(responseResults, function (partner) {
                    return flattenPartnerLocations(partner);
                });

                partners = _.flatten(partners);
                if (mappedQuery.searchText.trim() !== "") {
                    partners = _.sortBy(partners, partnerResultRelevance);
                } else {
                    partners = _.sortBy(partners, "distance");
                }

                return partners;
            }

            function partnerResultRelevance(partner) {
                if (mappedQuery.searchText.trim() !== "") {
                    //score depending on how well the name matches the search text
                    if (partner.name.trim().toLowerCase() === mappedQuery.searchText.trim().toLowerCase()) {
                        return -1;
                    } else {
                        //weighted depending on how much of the term matches, but will never exceed a perfect match
                        var score = 0;
                        var words = mappedQuery.searchText.trim().toLowerCase().split(" ");
                        var wordCount = words.length + 1;
                        words.forEach(function (word) {
                            if (partner.name.toLowerCase().indexOf(word) >= 0) {
                                score -= (1 / wordCount);
                            }
                        });

                        if (score === 0) {
                            return partner.distance;
                        } else {
                            return score;
                        }
                    }
                } else {
                    return partner.distance;
                }
            }

            function flattenPartnerLocations(partner) {
                var partnerBase = _.extend({}, partner);
                delete partnerBase.locations;

                var partnerLocations = _.map(partner.locations, function (location) {
                    location.flattenedAddress = [location.addressLine1, location.addressLine2, location.city, location.stateOrCounty, location.postalCode, location.country].filter(function (str) {
                        return str !== undefined && str.trim() !== "";
                    }).map(function (str) {
                        return str.replace(/,\s*$/, "");
                    }).join(", ");
                    return _.extend({}, partnerBase, location);
                });

                _.each(partnerLocations, function (partnerLocation) {
                    partnerLocation.locId = partnerLocation.id;
                });

                return partnerLocations;
            }

            function setPartnerSearchResultTitle(numberOfFoundResults) {
                var currSearchPartnerStatsLabel = partnerSearchTitleLabel.replace("#", numberOfFoundResults);
                $partnerSearchStatsTitle.html(currSearchPartnerStatsLabel);
            }

            function setPartnerSearchTerms() {
                var queryParts = [
                    mappedQuery.searchText.trim(),
                    mappedQuery.partnerType == null ? "" : mappedQuery.partnerType,
                    mappedQuery.location.address,
                    mappedQuery.location.distance + " " + mappedQuery.metricUnits
                ];

                var queryTerms = queryParts.filter(function (val) {
                    return val != "";
                }).join(", ");

                var currSearchTermsLabel = searchTermsLabel.replace("#", "'<strong>" + queryTerms + "</strong>'");
                $partnerSearchTermsSpan.html(currSearchTermsLabel);
            }

            function checkIfThereIsNoResults(partners) {
                if (partners.length < 1) {
                    $noResultsDiv.removeClass("hidden");
                    $hideOnLoadDiv.hide();
                    return true;
                } else {
                    $noResultsDiv.addClass("hidden");
                    return false;
                }
            }

            function setPartnerSearchResultTemplate() {
                var currTemplate = partnerSearchResultTemplate.replace("#SpecialismsTitle#", specialismsTitle);
                currTemplate = currTemplate.replaceAll("#ShowContactsDetailsLabel#", showContactsDetailsLabel);
                currTemplate = currTemplate.replaceAll("#HideContactsDetailsLabel#", hideContactsDetailsLabel);
                currTemplate = currTemplate.replace("#DescriptionTitle#", descriptionTitle);
                currTemplate = currTemplate.replaceAll("#ContactPartnerButton#", contactPartnerButton);


                var _partnerSearchResultTemplate = _.template(currTemplate);
                var html = "";
                html += _partnerSearchResultTemplate(results);
                $partnerSearchResultsTemplateDiv.html(html);
                window.scrollTo(0, 0);

                return currTemplate;
            }

            function setPagination(partnerSearchResultTemplateAfterDatasourceReplacement) {
                $paginationContainer.pagination({
                    dataSource: filteredResults.partners,
                    pageSize: numberOfResultsPerPage,
                    showNavigator: true,
                    autoHidePrevious: true,
                    autoHideNext: true,
                    formatNavigator: "<div class='stats'>" + partnerSearchPaginationStatsLabel + "</div>",
                    callback: function (partnersOnCurrentPage, pagination) {
                        var _partnerSearchResultTemplate = _.template(partnerSearchResultTemplateAfterDatasourceReplacement);
                        var html = "";

                        html += _partnerSearchResultTemplate({
                            partners: partnersOnCurrentPage, options: {
                                HideEmail: hideEmail,
                                HideWebsite: hideWebsite,
                                HideTelephone: hideTelephone
                            }, metricUnits: mappedQuery.metricUnits
                        });
                        $partnerSearchResultsTemplateDiv.html(html);

                        var fromNumber = pagination.pageNumber * pagination.pageSize - (pagination.pageSize - 1);
                        var toNumber = partnersOnCurrentPage.length < pagination.pageSize ? pagination.totalNumber : pagination.pageNumber * pagination.pageSize;
                        var currPartnerSearchPaginationStatsLabel = partnerSearchPaginationStatsLabel.replace("#", fromNumber + " - " + toNumber);
                        currPartnerSearchPaginationStatsLabel = currPartnerSearchPaginationStatsLabel.replace("##", pagination.totalNumber);
                        $(".stats", scope).html(currPartnerSearchPaginationStatsLabel);

                        if (partnersOnCurrentPage.length > 0) {
                            scrollToResults();
                        }
                    }
                });
            }

            function scrollToResults() {
                var stickyNavHeight = calculateStickyNavHeight();

                if ($(".js-partner-search-stats").length > 0) {
                    $("html, body").animate({
                        scrollTop: $(".js-partner-search-stats").offset().top - stickyNavHeight
                    }, 500);
                }
            }

            eventManager.subscribe("partner-search-apply-filter-triggered", function (selectedFilters, partnerFilterMatchingResultsLabel) {
                filteredResults.partners = filteredPartners(selectedFilters);
                var partnerSearchResultTemplateAfterDatasourceReplacement = setPartnerSearchResultTemplate();
                var variantTitles = selectedFilters.map(function (selectedFilter) {
                    return selectedFilter.variantTitle;
                });
                if (variantTitles.length > 0) {
                    var currSearchTermsLabel = partnerFilterMatchingResultsLabel.replace("#", filteredResults.partners.length);
                    var variants = "<strong>" + variantTitles.join(", ") + "</strong>";
                    currSearchTermsLabel = currSearchTermsLabel.replace("##", variants);
                    $partnerMatchingFilterResultsSpan.html(currSearchTermsLabel);
                } else {
                    $partnerMatchingFilterResultsSpan.html("");
                }

                eventManager.trigger("partner-search-map-triggered", filteredResults.partners, mappedQuery.location, true);

                setPagination(partnerSearchResultTemplateAfterDatasourceReplacement);
            });

            function filteredPartners(selectedFilters) {
                var selectedNames = selectedFilters.map(function (selectedFilter) {
                    return selectedFilter.variantName;
                });
                if (selectedFilters.length == 0) {
                    return results.partners;
                }

                var partners = _.filter(results.partners, function (partner) {
                    var specialisms = _.filter((partner.variants || []), { type: "specialism" });
                    specialisms = _.map(specialisms, function (specialism) {
                        return specialism.variantName;
                    });

                    return _.difference(selectedNames, specialisms).length === 0;
                });

                return partners;
            };

            eventManager.subscribe("partner-search-triggered", function (scope, query) {
                mappedQuery.location.address = query.location;
                mappedQuery.location.latitude = query.latitude;
                mappedQuery.location.longitude = query.longitude;
                mappedQuery.location.distance = query.distance;
                mappedQuery.searchText = query.businessName.trim();
                mappedQuery.partnerType = query.partnerType;
                mappedQuery.location.unit = query.unit;
                mappedQuery.useRegionBias = query.useRegionBias;
                mappedQuery.location.country = query.country;
                mappedQuery.metricUnits = query.metricUnits;
                showResults();
            });

            $(document).on("click", ".show-detail-toggle", scope, function (event) {
                event.preventDefault();
                var elementId = event.currentTarget.name;
                var clickedPartner = results.partners.filter(function (partner) {
                    return partner.locId == elementId;
                });

                eventManager.trigger("partner-search-map-triggered", clickedPartner, mappedQuery.location, false);

                $(".more-partner-details").css("display", "none");
                $(".partner-details .score-button-group").show();
                $(".specialisms").addClass("ellipsis");
                scrollToTheTopOfSelectedArticle(elementId);
                $(".more-partner-details." + elementId).css("display", "flex");
                $(".partner-details .score-button-group." + elementId).hide();
                $(".specialisms." + elementId).removeClass("ellipsis");
                var eventSchema = bodySelectEvent.GenerateEventMetadata(scope, "expand");
                tealium.event(eventSchema);
            });

            $(document).on("click", ".hide-detail-toggle", scope, function (event) {
                event.preventDefault();
                var elementId = event.currentTarget.name;
                eventManager.trigger("partner-search-map-triggered", filteredResults.partners, mappedQuery.location, true);

                $(".more-partner-details").css("display", "none");
                $(".partner-details .score-button-group." + elementId).show();
                $(".specialisms." + elementId).addClass("ellipsis");
                scrollToTheTopOfSelectedArticle(elementId);
                var eventSchema = bodySelectEvent.GenerateEventMetadata(scope, "expand");
                tealium.event(eventSchema);
            });

            function scrollToTheTopOfSelectedArticle(elementId) {
                var stickyNavHeight = calculateStickyNavHeight();

                $("html, body").animate({
                    scrollTop: $("article#" + elementId).offset().top - stickyNavHeight
                }, 500);
            }

            function calculateStickyNavHeight() {
                var stickyNav = $(".sticky-nav.stick");
                var stickyNavHeight = 0;

                if (stickyNav.length > 0 && (stickyNav.css("top") === "0" || stickyNav.css("top") === "0px") && (stickyNav.css("position") === "sticky") || (stickyNav.css("position") === "fixed")) {
                    stickyNavHeight = $(".sticky-nav.stick").height();
                }
                return stickyNavHeight;
            }

            $(document).on("click", ".showContactModal", function (event) {
                var email = results.partners.filter(function (partner) {
                    return partner.id === event.target.id;
                })[0].email;

                var partnerName = results.partners.filter(function (partner) {
                    return partner.id === event.target.id;
                })[0].name;

                if (territory === "ES" && $(".contact-partner-name").length > 0) {
                    $(".contact-partner-name").val(partnerName);
                }

                if ($partnerContacted === email) {
                    $(".contact-form-first-page").addClass("hidden");
                    $(".contact-form-second-page").removeClass("hidden");
                    $(".modal.fade").modal("show");
                } else {
                    eventManager.trigger("partner-search-contact-form", email);
                    $(".modal.fade").modal("show");
                }

                var extendedData = {
                    "partnername": $(this).data("tracking"),
                    "contactoption": $(this).data("contactoption"),
                    "label": $(this).text()
                };
                var eventSchema = findPartnerSearch.GenerateEventMetadata(scope, extendedData);
                tealium.event(eventSchema);
            });

            $(document).on("click", ".close.partner-search-modal", function (event) {
                $(".modal.fade").modal("hide");
                $(".aria-hidden").css("display", "none");
                $(".contact-form-first-page").removeClass("hidden");
                $(".contact-form-second-page").addClass("hidden");
            });

            var submitClickTimeout = undefined;
            $(document).on("click", ".partner-contact-form .submit-button", function (event) {
                if (!submitClickTimeout) {
                    submitClickTimeout = setTimeout(function () {
                        if ($(".field-validation-error").length === 0) {
                            $partnerContacted = $(".contact-partner-email").val();
                            $(".contact-form-first-page").toggleClass("hidden");
                            $(".contact-form-second-page").toggleClass("hidden");
                        }
                    },
                        100);
                }
            });

            eventManager.subscribe("partner-search-pin-click-triggered", function (locId) {
                var orderNumberOfClickedPin = filteredResults.partners.map(function (e) { return e.locId; }).indexOf(locId) + 1;
                var pageNumber = Math.ceil(orderNumberOfClickedPin / numberOfResultsPerPage);
                openPageForSelectedPartnerAndShowDetails(pageNumber, locId);
            });

            function openPageForSelectedPartnerAndShowDetails(pageNumber, locId) {
                //Note, if the pagination plugin changes then this event will need to change too
                $paginationContainer.trigger("__pagination-go", pageNumber);
                $(".show-detail-toggle." + locId).trigger("click");
            }
        }

        return function initPartnerSearch(args) {
            return args.IsExperienceEditorEditing === false ?
                new PartnerSearchResults(args.scope,
                    args.PartnerSearchTitleLabel,
                    args.ShowContactsDetailsLabel,
                    args.HideContactsDetailsLabel,
                    args.SearchTermsLabel,
                    args.PartnerSearchPaginationStatsLabel,
                    args.SpecialismsTitle,
                    args.DescriptionTitle,
                    args.CertificationsTitle,
                    args.VisitMarketplace,
                    args.ContactPartnerButton,
                    args.Territory,
                    args.NumberOfResults,
                    args.HideEmail,
                    args.HideWebsite,
                    args.HideTelephone,
                    args.UseJsonData) : null;
        };
    });
